





























import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class DialogoDeConfirmacaoDeReenvio extends Vue {
	@Prop({ type: Boolean, default: false }) value!: boolean
	@Prop({ type: Number, default: 0 }) quantidade!: number
	@Prop({ type: Boolean, default: false }) temItemDePreco!: boolean
	@Prop({ type: Boolean, default: false }) integracaoPausada!: boolean
	@Prop({ type: Boolean, default: false }) reenviando!: boolean

	get mostrar() {
		return this.value
	}

	set mostrar(valor: boolean) {
		this.$emit('input', valor)
	}
}
